import { useState } from 'react';
/**
 * Local state is just for tracking visual state, real
 * state is handled by redux. We dont have reducer though
 * because change = page reload, so you have two states to
 * manage visual toggle state and the external redux state.
 */ export function useFakeToggleState(initialState, onToggle) {
    const [toggleState, setToggleState] = useState(initialState);
    const onClick = ()=>{
        // if the switch is already toggled, do nothing
        if (toggleState !== initialState) {
            return;
        }
        setToggleState(!toggleState);
        onToggle && onToggle(initialState);
    };
    return {
        onClick,
        toggleState
    };
}
